var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',{staticStyle:{"text-align":"center"}},[_vm._v("Copyright © 2022 逛球街. All rights reserved.")])
}
var staticRenderFns = []

export { render, staticRenderFns }